import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import FiftyOnetripsLogo from '../../assets/images/51trips-logo-black.svg?react'

export const AuthPage: React.FC = () => {
  const { t } = useTranslation()

  const location = useLocation()

  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname === '/auth') {
      navigate('/auth/login', { replace: true })
    }
  }, [location.key])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-neutralBlack-100 px-4 py-14">
      <div className="w-full max-w-[392px] flex flex-col items-center gap-6">
        <FiftyOnetripsLogo className="w-24" />

        <div className="w-full bg-white border border-neutralBlack-200 rounded-2xl shadow-sm px-7 py-8">
          <Outlet />
        </div>

        <p className="text-[12.5px] text-neutralBlack-500">
          {t('supportHelp', { ns: 'auth', supportEmail: 'soporte@51trips.com' })}
        </p>
      </div>
    </div>
  )
}
